import Book from './Book'

export default Book
// eslint-disable-next-line import/export
export * from './Book'
